import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addLeadsource,
  getLeadsources,
  getLeadsource,
  editLeadsource,
  deleteLeadsource,
  getAllLeadsources,
} from "../../store/actions/leadsource_action";
import { SEARCH_TERMS } from "../enums/leadsources_enum";
// Get All Data
export const useAllLeadsources = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.leadsource);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteLeadsource(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getLeadsources({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getLeadsources({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getLeadsources({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleLeadsource = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.leadsource);
  useEffect(() => {
    dispatch(getLeadsource(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateLeadsource = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addLeadsource(data));
  };
  return [addData];
};
export const useUpdateLeadsource = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editLeadsource(id, data));
  };
  return [updateData];
};

export const useSelectAllLeadsource = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.leadsource);
    useEffect(() => {
      dispatch(getAllLeadsources());
    }, []);
    return [data];
  };          